// Shared helper for the Dashboard starter checklist. Any page can call
// markChecklistDone(userId, itemId) after a real action completes (e.g.
// Collections calls it after a successful Add Phrase submit), and the
// Dashboard picks it up via the 'onboarding-checklist-updated' event.
//
// One place instead of five inline try/JSON.parse blocks scattered around.

const doneKey = (userId) => `onboarding_checklist_done_${userId}`;

export function markChecklistDone(userId, itemId) {
    if (!userId || !itemId) return;
    try {
        const key = doneKey(userId);
        const arr = JSON.parse(localStorage.getItem(key) || '[]');
        if (arr.includes(itemId)) return;
        arr.push(itemId);
        localStorage.setItem(key, JSON.stringify(arr));
        window.dispatchEvent(new CustomEvent('onboarding-checklist-updated'));
    } catch { /* localStorage disabled — safe to ignore */ }
}
